export enum PaymentTypeEnum {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}
